var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInprocessInverted = function SvgInprocessInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A623",
    fillRule: "nonzero",
    d: "M15 19.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm.643-3.469l.668.553a.496.496 0 01.042.742.607.607 0 01-.807.039l-.85-.703a.503.503 0 01-.187-.439.487.487 0 01-.009-.095v-2.102c0-.29.256-.526.572-.526.315 0 .571.235.571.526v2.005z"
  }))));
};
export default SvgInprocessInverted;